<template>
  <div class="main">
    <template v-if=saved>
      <div class="alert alert-primary" role="alert">data saved</div>
    </template>
    <form class="form-inline" v-on:submit.prevent="onSubmit">
      <div class="form-group col-mb-2">
        <input class="form-control" v-model="searchWord" />
      </div>
      <div class="form-group col-md-4">
        <button v-on:click="search" class="btn btn-primary">Search</button>
      </div>
    </form>
    <hr />
    <div class="form-row">
      <div class="form-group col-md-2">
        <input id="us" type="text" class="form-control" v-model="vocabulary" placeholder="" />
      </div>
      <div class="form-group col-md-4">
        <button class="btn btn-primary" v-on:click="save">Save</button>
      </div>
      <div class="form-group col align-self-end">
        <button class="btn btn-danger" v-on:click="deleteWord">Delete</button>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-4">
        <label for="us">US</label>
        <input id="us" type="text" class="form-control" v-model="pronunciation" placeholder="" />
      </div>
      <div class="form-group col-md-4">
        <label>UK</label>
        <input type="text" class="form-control" v-model="ukPronunciation" placeholder="" />
      </div>
    </div>
    <div class="form-group">
      <label>中文解釋- 片語 名詞 形容詞 動詞 副詞 縮寫 語助詞</label>
      <textarea class="form-control" rows="5" v-model="ch" placeholder="add ch explain"></textarea>
    </div>
    <div class="form-group">
      英文解釋
      <textarea class="form-control" rows="5" v-model="en" placeholder="add en explain"></textarea>
    </div>
    <div class="form-group">
      句子
      <textarea class="form-control" rows="7" v-model="sentence" placeholder="sentence"></textarea>
    </div>
    <div class="form-group">
      詞性
      <textarea class="form-control" rows="3" v-model="tense" placeholder="tense"></textarea>
    </div>
    <div class="form-group">
      同義字
      <textarea class="form-control" v-model="synonym" placeholder="synonym"></textarea>
    </div>
    <div class="form-group">
      反義字
      <textarea class="form-control" v-model="antonym" placeholder="antonym"></textarea>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Word',
  props: {
    wordRef: Object
  },
  data: function() {
    return  {
      searchWord: 'boy',
      vocabulary: '',
      ch: '',
      en: '',
      pronunciation: '',
      sentence: '',
      tense: '',
      ukPronunciation: '',
      synonym: '',
      antonym: '',
      saved: false
    }
  },
  firebase: function() {
    return {
      word: {
        source: this.wordRef.child(this.searchWord).child('detail'),
        asObject: true,
        readyCallback: function () {
          this.$_parseData();
        }
      }
    }
  },
  methods: {
    search: function() {
      if(this.searchWord) {
        this.saved = false;
        this.$bindAsObject('word', this.wordRef.child(encodeURIComponent(this.searchWord.toString()).replace(/\./g, '%2E')).child('detail'), null, () => this.$_parseData());
      }
    },
    save: function() {
      if(this.vocabulary) {
        const json = {};
        json.word = this.vocabulary.toString();
        if(this.pronunciation) {
          json.pronunciation = this.pronunciation.toString().trim();
        }
        if(this.ukPronunciation) {
          json.ukPronunciation = this.ukPronunciation.toString().trim();
        }
        if(this.ch) {
          const chExplain = {};
          this.ch.toString().split('\n').forEach(element => {
              const arr = element.split('@');
              if(arr.length == 2) {
                const type = arr[0];
                const content = arr[1];
                chExplain[type] = content.split('$');
              }
          });
          json.chExplain = JSON.stringify(chExplain);
        }
        if(this.en) {
          const enExplain = {};
          this.en.toString().split('\n').forEach(element => {
              const arr = element.split('@');
              if(arr.length == 2) {
                const type = arr[0];
                const content = arr[1];
                enExplain[type] = content.split('$');
              }
          });
          json.enExplain = JSON.stringify(enExplain);
        }
        if(this.sentence) {
          const sentence = [];
          this.sentence.toString().split('\n').forEach(element => {
              const arr = element.split('@');
              if(arr.length == 2) {
                const en = arr[0];
                const ch = arr[1];
                sentence.push({ en, ch })
              }
          });
          json.sentence = JSON.stringify(sentence);
        }
        if(this.tense) {
          const tense = [];
          this.tense.toString().split('\n').forEach(element => {
              const arr = element.split('@');
              if(arr.length == 2) {
                const title = arr[0];
                const content = arr[1];
                tense.push({ title, content })
              }
          });
          json.tense = JSON.stringify(tense);
        }

        const synonym = {};
        if(this.synonym) {
          const s = [];
          this.synonym.toString().split('\n').forEach(element => {
              const arr = element.split('@');
              if(arr.length == 2) {
                const ch = arr[0];
                const en = arr[1].split(',').map(element => element.trim());
                s.push({ ch, en });
              }
          });
          synonym['同義字'] = s;
        }
        if(this.antonym) {
          const s = [];
          this.antonym.toString().split('\n').forEach(element => {
              const arr = element.split('@');
              if(arr.length == 2) {
                const ch = arr[0];
                const en = arr[1].split(',').map(element => element.trim());
                s.push({ ch, en });
              }
          });
          synonym['反義字'] = s;
        }
        if(Object.keys(synonym > 0)) {
            json.synonym = JSON.stringify(synonym);
        }

        this.wordRef.child(encodeURIComponent(this.vocabulary.toString()).replace(/\./g, '%2E')).child('detail')
          .set(json)
          .then(() => {
            this.saved = true;
          });
      }
    },
    deleteWord: function() {
      if (confirm('Delete?')) {
        if(this.vocabulary) {
          this.wordRef.child(encodeURIComponent(this.vocabulary.toString()).replace(/\./g, '%2E'))
            .set(null)
            .then(() => {
              this.saved = true;
              this.searchWord = '';
              this.vocabulary= '';
              this.ch= '';
              this.en= '';
              this.pronunciation= '';
              this.sentence= '';
              this.tense= '';
              this.ukPronunciation= '';
              this.synonym= '';
              this.antonym= '';
            });
        }
      }
    },
    $_parseData: function() {
      this.ch = '';
      this.en = '';
      this.sentence = '';
      this.tense = '';
      this.synonym = '';
      this.antonym = '';

      const w = this.word;
      this.vocabulary = w.word;
      this.pronunciation = w.pronunciation;
      this.ukPronunciation = w.ukPronunciation;

      if(w.chExplain) {
        const json = JSON.parse(w.chExplain);
        this.ch = Object.keys(json)
                    .map(key => `${key}@${json[key].join('$')}`)
                    .join('\n');
      }
      if(w.enExplain) {
        const json = JSON.parse(w.enExplain);
        this.en = Object.keys(json)
                    .map(key => `${key}@${json[key].join('$')}`)
                    .join('\n');
      }
      if(w.sentence) {
        const jsonArr = JSON.parse(w.sentence);
        this.sentence = jsonArr.map(s => `${s.en}@${s.ch}`).join('\n');
      }
      if(w.tense) {
        const jsonArr = JSON.parse(w.tense);
        this.tense = jsonArr.map(s => `${s.title}@${s.content}`).join('\n');
      }
      if(w.synonym) {
        const json = JSON.parse(w.synonym);
        if(json['同義詞'] || json['同義字']) {
          const arr = json['同義詞'] || json['同義字'];
          this.synonym = arr.map(j => {
            return `${j.ch}@${j.en.join(',')}`
          }).join('\n');
        }
        if(json['反義詞'] || json['反義字']) {
          const arr = json['反義詞'] || json['反義字'];
          this.antonym = arr.map(j => {
            return `${j.ch}@${j.en.join(',')}`
          }).join('\n');
        }
      }
    }
  }
}
</script>

<style>
  .main {
    margin: 16px;
  }
  textarea {
    width: 100%;
    height: 90px;
  }
</style>
